var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.436,
    r: 10,
    stroke: "#19425A",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.436C12.4271 16.0679 11.7395 16.436 11 16.436C10.2605 16.436 9.57285 16.0679 9 15.436",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.936C7.71357 10.6201 7.36974 10.436 7 10.436C6.63026 10.436 6.28643 10.6201 6 10.936",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.936C15.7136 10.6201 15.3697 10.436 15 10.436C14.6303 10.436 14.2864 10.6201 14 10.936",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.43604C9.34315 1.43604 8 2.77918 8 4.43604C8 6.09289 9.34315 7.43604 11 7.43604C11.7684 7.43604 12.4692 7.14718 13 6.67214",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabiesIcon);
export default __webpack_public_path__ + "static/media/babies-icon.d1d96209c9c36bf45356f931eb7c44a3.svg";
export { ForwardRef as ReactComponent };